/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function ThumbsUpSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <g clipPath="url(#clip0_1318_1143)">
                <path d="M2.53242 4.36372H0.633104C0.465194 4.36372 0.304162 4.42637 0.185432 4.5379C0.0667018 4.64943 0 4.80069 0 4.95841V10.3106C0 10.6261 0.133404 10.9286 0.370864 11.1516C0.608324 11.3747 0.930389 11.5 1.26621 11.5H1.89931C2.23513 11.5 2.5572 11.3747 2.79466 11.1516C3.03212 10.9286 3.16552 10.6261 3.16552 10.3106V4.95841C3.16552 4.80069 3.09882 4.64943 2.98009 4.5379C2.86136 4.42637 2.70032 4.36372 2.53242 4.36372Z" />
                <path d="M10.7336 4.36372H8.23035L9.21673 1.68762C9.24909 1.44273 9.18925 1.19493 9.04758 0.987129C8.9059 0.779327 8.69132 0.624614 8.44098 0.549786C8.19065 0.474959 7.92034 0.48473 7.67687 0.577407C7.4334 0.670084 7.23211 0.839829 7.10786 1.05724C6.3761 2.23029 5.47557 3.30292 4.43173 4.24478V9.94548H4.5039C5.83912 10.2922 7.60674 10.9053 9.24332 10.9053C10.1297 10.9053 10.2512 10.5925 10.4336 10.1221L11.9239 5.95927C11.9934 5.7796 12.0157 5.58685 11.9891 5.39733C11.9624 5.20782 11.8875 5.02713 11.7708 4.87057C11.654 4.71402 11.4987 4.58621 11.3182 4.49798C11.1377 4.40975 10.9372 4.3637 10.7336 4.36372Z" />
            </g>
            <defs>
                <clipPath id="clip0_1318_1143">
                    <rect width="12" height="12" />
                </clipPath>
            </defs>
        </svg>
    );
}
